module.exports = "../../static/img/razvivaushSreda.1385b22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/about_us_main/razvivaushSreda.jpg
// module id = N+ID
// module chunks = 1